import { createStructuredSelector } from 'reselect';

import { routeSelectedSelector } from '@selectors/routesSelector';
import { legendVisibilitySelector } from '@selectors/uiSelector';

export const structuredSelector = createStructuredSelector({
  routeSelected: routeSelectedSelector,
  legendOpened: legendVisibilitySelector,
});

export type StructuredSelectorProps = {
  routeSelected: {
    routeGeoJSON: [
      {
        coordinates: [number];
        type: string;
      }
    ];
    startPoint: {
      className: string;
      latitude: number;
      longitude: number;
    };
    routeStyleHide: boolean;
  };
  legendOpened: boolean;
};
